import { IProductRepository } from '../../../domain/repositories/IProductRepository';
import { Product } from '../../../domain/entities/Product';

export interface CreateProductDTO {
    name: string;
    value: number;
    description?: string;
    organizationId: string;
    userId?: string;
}

export class CreateProductUseCase {
    constructor(private readonly productRepository: IProductRepository) { }

    async execute(dto: CreateProductDTO): Promise<Product> {
        // Gera ID temporário (será substituído pelo UUID do Supabase)
        const tempId = `temp_${Date.now()}`;

        // Cria entidade (validações automáticas na entidade)
        const product = new Product(
            tempId,
            dto.name,
            dto.value,
            dto.description || '',
            new Date(),
            new Date(),
            dto.userId
        );

        // Persiste no repositório
        const savedProduct = await this.productRepository.save(product, dto.organizationId, dto.userId);

        return savedProduct;
    }
}
